import Container from "./MessageBubbleStyle"

export default function MessageBubble({ left, text, date, sending = false }) {

  function GetClass(isLeft: boolean, sending: boolean): string {
    return isLeft ? "left" : "right" + (sending ? " sending" : "");
  }

  function GetHour(timestamp) {
    const date = new Date(timestamp);
    const parts = date.toLocaleTimeString().split(':');
    if (parts.length < 2) {
      return "Sem Hora";
    }
    return `${parts[0]}:${parts[1]}`;
  }

  return (
    <Container>
      <div className={GetClass(left, sending)}>
        <p>{text}</p>
        <p id="message-timestamp">{GetHour(date)}</p>
      </div>
    </Container>
  );
}
